<template>
  <div>
    <b-modal
      id="modal-model-instruments"
      :title="editModelInstrument.id ? $t('reference.edit_ins_variant') : $t('reference.add_ins_variant')"
      cancel-variant="outline-secondary"
      :ok-title="editModelInstrument.id ? $t('edit') : $t('save')"
      :ok-variant="editModelInstrument.id ? 'warning' : 'success'"
      :cancel-title="$t('cancel')"
      centered
      no-close-on-backdrop
      @show="onShow"
      @ok="onSubmitInstrumentModel"
    >
      <b-form>
        <validation-observer ref="instructorModelValidations">
          <b-form-group
            :label="$t('reference.name')"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('reference.name')"
              rules="required"
            >
              <b-form-input
                v-model="ins.title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            :label="$t('reference.ins_photo')"
          >
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('reference.ins_photo')"
              rules="required"
            > -->
              <b-form-file
                v-model="ins.image"
                :placeholder="$t('reference.upload_photo')"
                :browse-text="$t('upload')"
              />
              <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions } from 'vuex'
import base64 from '@/mixins/base64'
import objective from '@/mixins/objective'

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BFormFile,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [
    base64,
    objective,
  ],
  props: {
    editModelInstrument: {
      type: Object,
      default: () => {
      },
      required: false,
    },
    type: {
      type: Number,
      default: null,
      required: false,
    },
  },
  data() {
    return {




      // ===============  PRIMARY_DATA_SECTION START ===============
      ins: {
        type: null,
        title: '',
        image: null,
      },
      // ===============  PRIMARY_DATA_SECTION END ===============




    }
  },
  methods: {
    ...mapActions('instruments', ['CREATE_INSTRUMENTS_MODEL_VARIANT', 'FETCH_INSTRUMENTS_MODEL_VARIANT', 'UPDATE_INSTRUMENTS_MODEL_VARIANT']),







    // ===============  ON_SHOW_SECTION START ===============
    onShow() {
      this.ins.type = this.type
      this.ins = {
        title: '',
        image: null,
      }

      if (!this.editModelInstrument) {
        return
      }

      if (typeof this.editModelInstrument === 'object' && this.editModelInstrument !== null) {
        this.ins.title = this.editModelInstrument.title
        this.ins.image = this.editModelInstrument.image
      }
    },
    // ===============  ON_SHOW_SECTION END ===============






    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmitInstrumentModel(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.ins.type = this.type

      await this.$refs.instructorModelValidations.validate()
        .then( async success => {
          if (!success) {
            this.$_errToast({message: this.$t('all_fields_are_required')});
            return
          }

          try {
            if (this.editModelInstrument.id) {
              const req = {
                id: this.editModelInstrument.id,
                ...this.ins,
              }
              if (!(req.image instanceof File)) this.$delete(req, 'image')
              const form = this.$_objectToFormData(req)
              await this.UPDATE_INSTRUMENTS_MODEL_VARIANT(form)
               
            } else {
              const formData = new FormData()
              if(this.ins && this.ins.image){
                formData.append('image', this.ins.image)
              }
              formData.append('type', this.ins.type)
              formData.append('title', this.ins.title)
              await this.CREATE_INSTRUMENTS_MODEL_VARIANT(formData)
            }

            await this.$parent.refresh2()
            await this.$bvModal.hide('modal-model-instruments')

            this.ins = {
              title: '',
              image: null,
            }

            this.$_okToast()
          } catch (err) {
            this.$_errToast(err)
          }
        })
    },
    // ===============  ON_SUBMIT_SECTION END ===============







  },
}
</script>
